// Format date like - Tuesday, July 20, 2021

import dateFormat from 'dateformat';

export const getISODateString = (newDate: any) => {
  // Date in ISO Format with Time Zone Offset
  return dateFormat(newDate, DateMasks.ISOFormat);
};

export const getDateWithTimeZoneOffset = (date: string | number) => {
  const extractedDate = new Date(date);
  return extractedDate;
};

export const getFormattedDate = (date: string, isDayVisible = true) => {
  /** Safari Mobile browser doesn't recognize when month or day have no leading zeros,
   * e.g, 2022-1-7, return invalid date when passed to new Date().
   * Hence replacing '-' with '/' => passing 2022/1/7 to date method works in both desktop and mobile browsers.  */
  const dateWithoutTime = date.split('T')[0].replace(/-/g, '/');
  const dateObj = new Date(dateWithoutTime);
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const dayNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  return `${isDayVisible ? `${dayNames[dateObj.getUTCDay()]}, ` : ''}${
    monthNames[dateObj.getUTCMonth()]
  } ${dateObj.getUTCDate()}, ${dateObj.getUTCFullYear()}`;
};

export const sortPaymentWithdrawSchedules = (
  paymentWithdrawSchedule1: any,
  paymentWithdrawSchedule2: any
) => {
  const date1 = new Date(paymentWithdrawSchedule1.paymentDate);
  const date2 = new Date(paymentWithdrawSchedule2.paymentDate);
  return date1.getTime() - date2.getTime();
};

export const formatDate = (date: any, mask: any = DateMasks.Default) =>
  dateFormat(date, mask, true);

export const DateMasks = {
  Default: 'mmmm d, yyyy',
  DayOnly: 'dS',
  MonthDayYearForwardSlash: 'mm/dd/yyyy',
  MonthDayYear: 'mmm dd, yyyy',
  MonthDay: 'mmm dd',
  ISOFormat: "yyyy-mm-dd'T'HH:MM:ss'Z'",
};
